// extracted by mini-css-extract-plugin
var _1 = "ApplicantDocumentChecklistAttach-moduleattachSelect__PuFda Select-moduleSelect__MROu3";
export { _1 as "attachSelect" }
